<div class="logout-container" fxFlexFill fxLayoutAlign="center center">
  <h1>Sie werden abgemeldet...</h1>
</div>
